import React from 'react'
import useOnClickOutside from 'support/hooks/use-on-click-outside'

export default function OnClickOutside ({ onClickOutside, children }) {
  const [elementRef, setElementRef] = React.useState()

  useOnClickOutside(elementRef, () => {
    if (typeof onClickOutside === 'function') {
      onClickOutside()
    }
  })

  return (
    <div ref={setElementRef}>
      {children}
    </div>
  )
}
